import type { OptionT } from "@patient-watch/forms";
import { renderOptionIcon } from "./optionIcons";
import { searchTextFor, type ResolvedOption } from "./resolveDictionary";

/** Maps resolved dictionary options onto the option shape that Select, ComboBox and MultiSelect take. */
export function toFormOptions(options: readonly ResolvedOption[]): OptionT[] {
    return options.map((option) => ({
        value: option.value,
        label: option.label,
        description: option.description,
        icon: renderOptionIcon(option.icon),
        searchText: searchTextFor(option) || undefined,
        locked: option.disabled,
        group: option.group,
    }));
}
